<template>
  <card class="summary-amount-card" :has-footer-padding="false">
    <template v-slot:header v-if="shareButtonProps && !outOfDate">
      <div class="header">
        <tiny-share-button class="card-share-button" v-bind="shareButtonProps" :create-impression-on-click="true"></tiny-share-button>
      </div>
    </template>
    <div class="card-content">
      <div class="intro" :class="{ 'out-of-date': outOfDate }" v-if="intro">{{ intro }}</div>
      <div class="title" :class="{ 'out-of-date': outOfDate }"><slot name="title"></slot></div>
      <div class="amount" :class="{ [variant]: true, 'long-number': numberIsLong, 'out-of-date': outOfDate }">
        <span v-if="blocked">***</span>
        <template v-else>
          <animated-number v-if="useAnimatedNumber" :value="amount" :formatter="format"/>
          <span v-else>{{ format(amount) }}</span>
          <span> ₪</span>
        </template>
      </div>
    </div>
    <template v-slot:footer v-if="hasFooterSlot">
      <div class="footer">
        <slot name="footer"></slot>
      </div>
    </template>
  </card>
</template>

<script>
import BaseUI from 'base-ui';
import _ from 'lodash';
import TinyShareButton from '@/base-components/share/TinyShareButton';

export default {
  name: 'SummaryAmountCard',
  components: {
    Card: BaseUI.Card,
    AnimatedNumber: BaseUI.AnimatedNumber,
    TinyShareButton,
  },
  props: {
    intro: {
      type: String,
      required: false,
    },
    amount: {
      type: Number,
      required: true,
    },
    variant: {
      type: String,
      required: false,
      default: 'black',
    },
    outOfDate: {
      type: Boolean,
      default: false,
    },
    useAnimatedNumber: {
      type: Boolean,
      required: false,
      default: false,
    },
    blocked: {
      type: Boolean,
      default: false,
    },
    shareButtonProps: {
      type: Object,
      default: () => undefined,
    },
  },
  computed: {
    numberIsLong() {
      return _.round(this.amount).toString().length > 4;
    },
    hasFooterSlot() {
      return !!this.$slots.footer;
    },
  },
  methods: {
    format(value) {
      const amount = Math.abs(Number(value));
      const result = amount.toLocaleString(undefined, { maximumFractionDigits: 0, minimumFractionDigits: 0 });
      const stringResult = result.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
      if (value < 0) {
        return `${stringResult}-`;
      }
      return stringResult;
    },
  },
};
</script>

<style lang="scss">
  @import '~base-ui/src/scss/riseup-colors';
  @import '../../scss/mixins';

  .summary-amount-card {
    position: relative;
    font-family: SimplerPro;
    padding-top: 10px;

    .header {
      text-align: left;
      margin: 0 -14px;
    }

    .card-content {
      display: flex;
      flex-direction: column;
      padding-bottom: 20px;

      .intro {
        @include cashflow-h2;
        margin-top: 10px;
        margin-bottom: 10px;

        &.out-of-date {
          color: $riseup_gray_2;
        }
      }

      .title {
        margin-bottom: 6px;
        @include cashflow-h1;

        &.out-of-date {
          color: $riseup_gray_2;
        }
      }

      .amount {
        font-size: 64px;
        color: $riseup_black;
        margin-top: 20px;

        &.long-number {
          font-size: 54px;
        }

        &.green {
          color: $riseup_green;
        }

        &.black {
          color: $riseup_black;
        }

        &.red {
          color: $riseup_danger_red;
        }

        &.out-of-date {
          color: $riseup_gray_2;
        }
      }
    }

    .footer {
      padding-top: 20px;
      padding-bottom: 20px;
    }
  }
</style>
